import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input,
	ChangeDetectorRef,
	SimpleChanges,
	OnChanges,
	Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * White Verification Modal
 */
@Component({
	selector: 'app-white-verification-modal',
	templateUrl: './white-verification-modal.component.html',
	styleUrls: ['./white-verification-modal.component.scss'],
})
export class WhiteVerificationModalComponent implements OnChanges {
	/** Submit button Name */
	submitButton: string = 'SUBMIT';
	/** Modal Title */
	@Input() title: string;
	/** Denote whether the close icon has to show on modal */
	@Input() showCloseIcon: boolean;
	/** Denote whether to show the modal submit button */
	@Input() showButtons: boolean;
	@Input() modalWrapperClass = 'u-verification-modal-wrapper';
	@Output() action: EventEmitter<string>;

	/**
	 * White Verification modal constructor
	 * @param cdr Angular Change detection reference
	 */
	constructor(private cdr: ChangeDetectorRef) {
		this.action = new EventEmitter<string>();
	}

	/**
	 * On Changes
	 * @param changes - SimpleChanges object
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes.showButtons) {
			this.showButtons = changes.showButtons.currentValue;
			this.cdr.detectChanges();
			this.cdr.reattach();
		}
		if (changes.modalWrapperClass) {
			this.modalWrapperClass = changes.modalWrapperClass.currentValue;
			this.cdr.detectChanges();
			this.cdr.reattach();
		}
	}

	/** Modal submit button
	 * *sending action as 'CLOSE' to parent component
	 */
	submit() {
		this.action.emit('SUBMIT');
	}

	/** Modal close button,
	 * sending action as 'CLOSE' to parent component */
	close() {
		this.action.emit('CLOSE');
	}
}
